export const GET_INDIVIDUAL_COEFFICIENTS_DRAFT = "GET_INDIVIDUAL_COEFFICIENTS_DRAFT";
export const CLEAR_INDIVIDUAL_COEFFICIENTS = "CLEAR_INDIVIDUAL_COEFFICIENTS";